export var DOES_NOT_ALLOW_FOR_ALL_COUNTRIES = 'does_not_allow_for_all_countries';
export var ALLOWS_FOR_ALL_COUNTRIES = 'allows_for_all_countries';
export var EXCEPTION_EXISTS = 'exception_exists';
export var DELAYED_PROOF_OF_ELP_VALUES = [DOES_NOT_ALLOW_FOR_ALL_COUNTRIES, ALLOWS_FOR_ALL_COUNTRIES, EXCEPTION_EXISTS];
export var TOEFL_NOT_REQUIRED_BAND_SCORE = 1;
export var IELTS_NOT_REQUIRED_BAND_SCORE = 1;
export var PTE_NOT_REQUIRED_BAND_SCORE = 10;
export var GMAT_NOT_REQUIRED_BAND_SCORE = 1;